import type { errors as en } from '@/i18n/locales/en/errors';
import type { Translation } from '@/i18n/types';

export const errors: Translation<typeof en> = {
  loading: '{{label}} yükleniyor…',
  forbidden: '{{label}} görmenize izin verilmiyor.',
  notFound: '{{label}} bulunamadı.',
  loadingFailed: '{{label}} yüklenemedi: {{message}}',
  submitForbidden: 'Bunu yapmanıza izin verilmiyor{{suffix}}',
  submitConflict: 'Bu, mevcut durumla çelişiyor{{suffix}}',
  submitGeneric: 'Bir şeyler ters gitti: {{message}}',
};
